import React from 'react';

import { ForgotPassword } from 'features/auth/components/ForgotPassword';
import { useTranslation } from 'hooks/useTranslation';
import { Title } from 'shared';

export const ForgotPasswordPage = () => {
  const { t } = useTranslation('auth');

  return (
    <>
      <Title title={t('forgetPassword')} />
      <ForgotPassword />
    </>
  );
};
